import {
  ModalType,
  useModalContext,
  useFeatureFlagContext,
  useCampaignContext,
} from 'modules/campaigns/editor/context';
import { MessageMedium } from 'modules/graphql/types';
import { CampaignState } from 'modules/domains/campaign';
import { SecondaryButton, BUTTON_SIZES } from 'ui/button';
import { Undo } from 'ui/icons';
import { CampaignPopover } from '../../../CampaignPopover';
import { CampaignPermissionCheck } from '../../CampaignPermissionCheck';

export const InAppRecallAction = () => {
  const { openModal } = useModalContext();
  const {
    campaign: { messageMedium, campaignState },
  } = useCampaignContext();

  const { isCampaignAnalyticsReactificationEnabled, isInAppRecallUIEnabled } =
    useFeatureFlagContext();

  const shouldDisplayRecallButton =
    messageMedium === MessageMedium.InApp &&
    isCampaignAnalyticsReactificationEnabled &&
    isInAppRecallUIEnabled;

  return shouldDisplayRecallButton ? (
    <CampaignPermissionCheck
      action="recall"
      ChildWrapper={CampaignPopover}
      additionalCheck={campaignState === CampaignState.Recalling}
      additionalCheckTooltip={'Recall in progress'}
    >
      <SecondaryButton
        data-test="in-app-recall-button"
        size={BUTTON_SIZES.LARGE}
        onClick={() => openModal(ModalType.InAppRecallModal)}
      >
        <Undo height={20} />
        Recall
      </SecondaryButton>
    </CampaignPermissionCheck>
  ) : null;
};
